import type { Column, ColumnDef, RowData } from '@tanstack/react-table';
import type { ExtendedColumnDef } from '../types';

export type TableColumnDef<
  TData extends RowData,
  TTexts = never,
> = ColumnDef<TData> &
  Pick<
    ExtendedColumnDef<TData, TTexts>,
    'Aggregation' | 'Filter' | 'GroupHeader' | 'cellPadding'
  >;

export function getTableColumnDef<TData extends RowData>(
  column: Column<TData>
): TableColumnDef<TData> {
  return column.columnDef as TableColumnDef<TData>;
}
